import { defineComponent as p, useAttrs as s, computed as m, h as d, createBlock as u, openBlock as C, resolveDynamicComponent as F, unref as h, defineAsyncComponent as g } from "vue";
const f = /* @__PURE__ */ p({
  __name: "TnIcon",
  props: {
    name: {},
    color: { default: "currentColor" },
    size: { default: "m" }
  },
  setup(I) {
    const o = I, { height: T, width: l } = s(), t = m(() => o.size === "xs" ? "16px" : o.size === "s" ? "20px" : o.size === "m" ? "22px" : o.size === "l" ? "26px" : o.size === "xl" ? "28px" : o.size === "2xl" ? "32px" : "22px"), r = p({
      setup() {
        return () => d("span", {
          "aria-hidden": "true",
          style: {
            width: l || t.value,
            height: T || t.value
          }
        });
      }
    });
    function n(i) {
      return g({
        loader: i,
        suspensible: !1,
        loadingComponent: r,
        errorComponent: r,
        delay: 0,
        onError() {
        }
      });
    }
    const c = {
      TnIcon0: n(() => import("./TnIcon0-D0Fhqukt.js")),
      TnIcon0Filled: n(() => import("./TnIcon0-filled-BEp7ze8s.js")),
      TnIcon0Outline: n(() => import("./TnIcon0-outline-p28yubnO.js")),
      TnIcon1: n(() => import("./TnIcon1-DQi4Iqny.js")),
      TnIcon1Filled: n(() => import("./TnIcon1-filled-ds_N1TTq.js")),
      TnIcon1Outline: n(() => import("./TnIcon1-outline-DDC-UHMm.js")),
      TnIcon2: n(() => import("./TnIcon2-CLuYKxxw.js")),
      TnIcon2Filled: n(() => import("./TnIcon2-filled-Cb8B1-ij.js")),
      TnIcon2Outline: n(() => import("./TnIcon2-outline-C92_4__9.js")),
      TnIcon3: n(() => import("./TnIcon3-LHPHjqIJ.js")),
      TnIcon3Filled: n(() => import("./TnIcon3-filled-BNqqaQ7t.js")),
      TnIcon3Outline: n(() => import("./TnIcon3-outline-BJNq16Bu.js")),
      TnIcon4: n(() => import("./TnIcon4-BrzSceIg.js")),
      TnIcon4Filled: n(() => import("./TnIcon4-filled-Da1FDWpf.js")),
      TnIcon4Outline: n(() => import("./TnIcon4-outline-DEcnO6Vp.js")),
      TnIcon5: n(() => import("./TnIcon5-Cdca58_Q.js")),
      TnIcon5Filled: n(() => import("./TnIcon5-filled-mS4ZaxL4.js")),
      TnIcon5Outline: n(() => import("./TnIcon5-outline-s1zsm_SM.js")),
      TnIcon6: n(() => import("./TnIcon6-CT3ydQnc.js")),
      TnIcon60DayFreeReturns: n(() => import("./TnIcon60-day-free-returns-aY4bEusk.js")),
      TnIcon6Filled: n(() => import("./TnIcon6-filled-rpTPAgdy.js")),
      TnIcon6Outline: n(() => import("./TnIcon6-outline-COBujoIH.js")),
      TnIcon7: n(() => import("./TnIcon7-Bj8qHNxc.js")),
      TnIcon7Filled: n(() => import("./TnIcon7-filled--gdAsvGT.js")),
      TnIcon7Outline: n(() => import("./TnIcon7-outline-wRb5DIk6.js")),
      TnIcon8: n(() => import("./TnIcon8-C1ZjfNH-.js")),
      TnIcon8Filled: n(() => import("./TnIcon8-filled-FAgHzdPe.js")),
      TnIcon8Outline: n(() => import("./TnIcon8-outline-C2pK_-7h.js")),
      TnIcon9: n(() => import("./TnIcon9-BXxC1uFg.js")),
      TnIcon9Filled: n(() => import("./TnIcon9-filled-BmcJG8ZP.js")),
      TnIcon9Outline: n(() => import("./TnIcon9-outline-CF7levYB.js")),
      TnIconAccount: n(() => import("./TnIconaccount-BKBA7lgb.js")),
      TnIconAI: n(() => import("./TnIconai-DgnK0kQd.js")),
      TnIconAIFilled: n(() => import("./TnIconai-filled-Dp5EW_z1.js")),
      TnIconAIOutline: n(() => import("./TnIconai-outline-DcuBt0BO.js")),
      TnIconAISymbol: n(() => import("./TnIconai-symbol-DddplhWB.js")),
      TnIconAISymbolFilled: n(() => import("./TnIconai-symbol-filled-CYAyHPTW.js")),
      TnIconAltRoute: n(() => import("./TnIconalt-route-CwB9nj1q.js")),
      TnIconAntenna: n(() => import("./TnIconantenna-bVsHRc4t.js")),
      TnIconAppleAirplay: n(() => import("./TnIconapple-airplay-DSwA--37.js")),
      TnIconApps: n(() => import("./TnIconapps-C0qaunPK.js")),
      TnIconAt: n(() => import("./TnIconat-C4Qcm0mD.js")),
      TnIconAttentionCircleFilled: n(() => import("./TnIconattention-circle-filled-Djdh5lZd.js")),
      TnIconAttentionCircleFlat: n(() => import("./TnIconattention-circle-flat-CmatWBeV.js")),
      TnIconAttentionCircleOutline: n(() => import("./TnIconattention-circle-outline-mXskcwiY.js")),
      TnIconBackspace: n(() => import("./TnIconbackspace-CZg7AyT8.js")),
      TnIconBackspaceFilled: n(() => import("./TnIconbackspace-filled-BATsQYop.js")),
      TnIconBankID: n(() => import("./TnIconbank-id-t5ocgaJ5.js")),
      TnIconBankIDApp: n(() => import("./TnIconbank-id-app-DJ67bLIP.js")),
      TnIconBankIDAppNegative: n(() => import("./TnIconbank-id-app-negative-A9-pYKhm.js")),
      TnIconBatteryCharging: n(() => import("./TnIconbattery-charging-CdwS0Z6o.js")),
      TnIconBatteryEmpty: n(() => import("./TnIconbattery-empty-BWrJQKnk.js")),
      TnIconBatteryFull: n(() => import("./TnIconbattery-full-D9x3EN4y.js")),
      TnIconBatteryHalf: n(() => import("./TnIconbattery-half-DrPm64cz.js")),
      TnIconBatteryLow: n(() => import("./TnIconbattery-low-BD2ATq7x.js")),
      TnIconBatteryQuarter: n(() => import("./TnIconbattery-quarter-uYlnQMwx.js")),
      TnIconBills: n(() => import("./TnIconbills-COYZ6jT5.js")),
      TnIconBookmarkFilled: n(() => import("./TnIconbookmark-filled-C-F_NHK_.js")),
      TnIconBookmarkOutline: n(() => import("./TnIconbookmark-outline-C_VZ0SCk.js")),
      TnIconBookmarks: n(() => import("./TnIconbookmarks-BxQcIWwX.js")),
      TnIconBranch: n(() => import("./TnIconbranch-ChFxQ-1r.js")),
      TnIconBullet: n(() => import("./TnIconbullet-Cddw6Svz.js")),
      TnIconBulletOutline: n(() => import("./TnIconbullet-outline-DFD48S1o.js")),
      TnIconBullhorn: n(() => import("./TnIconbullhorn-HmglCtih.js")),
      TnIconBusiness: n(() => import("./TnIconbusiness-B6SrphDB.js")),
      TnIconCable: n(() => import("./TnIconcable-C8NUn7m8.js")),
      TnIconCalendar: n(() => import("./TnIconcalendar-BoYJ9Aar.js")),
      TnIconCallEnd: n(() => import("./TnIconcall-end-DaggiGOO.js")),
      TnIconCallForwarded: n(() => import("./TnIconcall-forwarded-Cp_yX1vY.js")),
      TnIconCallForwardedFilled: n(() => import("./TnIconcall-forwarded-filled-B8M6KmVP.js")),
      TnIconCallIncoming: n(() => import("./TnIconcall-incoming-Dw8I7Gew.js")),
      TnIconCallIncomingFilled: n(() => import("./TnIconcall-incoming-filled-B8foC9kP.js")),
      TnIconCallInUse: n(() => import("./TnIconcall-in-use-CW6dsBfi.js")),
      TnIconCallInUseFilled: n(() => import("./TnIconcall-in-use-filled-Do7UIJGb.js")),
      TnIconCallMissed: n(() => import("./TnIconcall-missed-DXNtHpbJ.js")),
      TnIconCallMissedFilled: n(() => import("./TnIconcall-missed-filled-BvXUotHL.js")),
      TnIconCallOff: n(() => import("./TnIconcall-off-CYDDIk-k.js")),
      TnIconCallOffFilled: n(() => import("./TnIconcall-off-filled-DrFLSvK4.js")),
      TnIconCallOutgoing: n(() => import("./TnIconcall-outgoing-DjW3IIph.js")),
      TnIconCallOutgoingFilled: n(() => import("./TnIconcall-outgoing-filled-Cl_hWP9Y.js")),
      TnIconCallPause: n(() => import("./TnIconcall-pause-BzwAb_eH.js")),
      TnIconCallPauseFilled: n(() => import("./TnIconcall-pause-filled-YDk4TgEW.js")),
      TnIconCamera: n(() => import("./TnIconcamera-KAzCAsFB.js")),
      TnIconCart: n(() => import("./TnIconcart-CZrXTJ4y.js")),
      TnIconCartNewItem: n(() => import("./TnIconcart-new-item-DJv-QkMv.js")),
      TnIconCatchUp: n(() => import("./TnIconcatch-up-DZlcx1kK.js")),
      TnIconChart: n(() => import("./TnIconchart-BETVYKfd.js")),
      TnIconCheckboxChecked: n(() => import("./TnIconcheckbox-checked-tAdKJ-wY.js")),
      TnIconCheckboxUnchecked: n(() => import("./TnIconcheckbox-unchecked-O_DkFOHC.js")),
      TnIconChevronDown: n(() => import("./TnIconchevron-down-DWO8aREF.js")),
      TnIconChevronLeft: n(() => import("./TnIconchevron-left-CyqxB9bh.js")),
      TnIconChevronRight: n(() => import("./TnIconchevron-right-nUEKluNw.js")),
      TnIconChevronsDown: n(() => import("./TnIconchevrons-down-FEal--H0.js")),
      TnIconChevronsLeft: n(() => import("./TnIconchevrons-left-D4NXfNDi.js")),
      TnIconChevronsRight: n(() => import("./TnIconchevrons-right-C8kFLaHl.js")),
      TnIconChevronsUp: n(() => import("./TnIconchevrons-up-KRVHF_R1.js")),
      TnIconChevronUp: n(() => import("./TnIconchevron-up-B0YmThOf.js")),
      TnIconChild1: n(() => import("./TnIconchild1-BIHwQMeQ.js")),
      TnIconChild2: n(() => import("./TnIconchild2-BBJF_bZf.js")),
      TnIconChromecastOff: n(() => import("./TnIconchromecast-off-CGWpS6Tc.js")),
      TnIconChromecastOn: n(() => import("./TnIconchromecast-on-C7mTWXQX.js")),
      TnIconClock: n(() => import("./TnIconclock-CISC8cMu.js")),
      TnIconClose: n(() => import("./TnIconclose-BxIz-idm.js")),
      TnIconClosePanelLeft: n(() => import("./TnIconclose-panel-left-DWhoFLPW.js")),
      TnIconClosePanelRight: n(() => import("./TnIconclose-panel-right-NksMxSVj.js")),
      TnIconCloudDownload: n(() => import("./TnIconcloud-download-BLxeDmrH.js")),
      TnIconCloudUpload: n(() => import("./TnIconcloud-upload-U4Sq_u9G.js")),
      TnIconCode: n(() => import("./TnIconcode-CZd_G0fw.js")),
      TnIconCoins: n(() => import("./TnIconcoins-CMBT8LmW.js")),
      TnIconCollapse: n(() => import("./TnIconcollapse-0pF8nY6v.js")),
      TnIconConnected: n(() => import("./TnIconconnected-CCTUJum6.js")),
      TnIconContentSwitcher: n(() => import("./TnIconcontent-switcher-BTydmYqi.js")),
      TnIconContractScreen: n(() => import("./TnIconcontract-screen-C5LpPle-.js")),
      TnIconCookie: n(() => import("./TnIconcookie-DQ__Tjrd.js")),
      TnIconCopy: n(() => import("./TnIconcopy-DWhcw8-Z.js")),
      TnIconCreditCard: n(() => import("./TnIconcredit-card-DiErWS-V.js")),
      TnIconCriticalFilled: n(() => import("./TnIconcritical-filled-DC8AtHdD.js")),
      TnIconCriticalFilledFlat: n(() => import("./TnIconcritical-filled-flat-QZvYPD8k.js")),
      TnIconCriticalOutline: n(() => import("./TnIconcritical-outline-C-uR7E6g.js")),
      TnIconCtaLeft: n(() => import("./TnIconcta-left-CusXTnWa.js")),
      TnIconCtaRight: n(() => import("./TnIconcta-right-Bf82DK7d.js")),
      TnIconCursor: n(() => import("./TnIconcursor-DBQkxA7f.js")),
      TnIconCursorInverted: n(() => import("./TnIconcursor-inverted-mXDuF1di.js")),
      TnIconCursorRays: n(() => import("./TnIconcursor-rays-C8fisHp-.js")),
      TnIconCursorRaysInverted: n(() => import("./TnIconcursor-rays-inverted-Efb_nroh.js")),
      TnIconCursorRipples: n(() => import("./TnIconcursor-ripples-CXeAQV-_.js")),
      TnIconCursorRipplesInverted: n(() => import("./TnIconcursor-ripples-inverted-DIjqrCQE.js")),
      TnIconCustomerService: n(() => import("./TnIconcustomer-service-C-s_nBfn.js")),
      TnIconDarkMode: n(() => import("./TnIcondark-mode-3TG5MLHw.js")),
      TnIconDarkModeFilled: n(() => import("./TnIcondark-mode-filled-DnrJ3oCR.js")),
      TnIconDashboard: n(() => import("./TnIcondashboard-FTyEYlq7.js")),
      TnIconDelete: n(() => import("./TnIcondelete-CjYpoen3.js")),
      TnIconDeleteFilled: n(() => import("./TnIcondelete-filled-UY5fpElu.js")),
      TnIconDelivery: n(() => import("./TnIcondelivery-CQsdflN1.js")),
      TnIconDeliveryExpress: n(() => import("./TnIcondelivery-express-BhO-Hgzh.js")),
      TnIconDevices: n(() => import("./TnIcondevices-CwN2FO25.js")),
      TnIconDiagonalDownLeft: n(() => import("./TnIcondiagonal-down-left-DuprmBgK.js")),
      TnIconDiagonalDownRight: n(() => import("./TnIcondiagonal-down-right-5YUkagHn.js")),
      TnIconDiagonalUpLeft: n(() => import("./TnIcondiagonal-up-left-C5zvgRJM.js")),
      TnIconDiagonalUpRight: n(() => import("./TnIcondiagonal-up-right-6h7CzINc.js")),
      TnIconDiscount: n(() => import("./TnIcondiscount-CB4SCify.js")),
      TnIconDocument: n(() => import("./TnIcondocument-DAFv8fiT.js")),
      TnIconDocumentAdd: n(() => import("./TnIcondocument-add-i1_ZHGHA.js")),
      TnIconDocumentDelete: n(() => import("./TnIcondocument-delete-BES7izQA.js")),
      TnIconDocumentDetails: n(() => import("./TnIcondocument-details-DwyW_gsb.js")),
      TnIconDolbyDigital: n(() => import("./TnIcondolby-digital-Bq04CaGy.js")),
      TnIconDown: n(() => import("./TnIcondown-CQW4ZtBy.js")),
      TnIconDownloadCircle: n(() => import("./TnIcondownload-circle-BtD4HS3y.js")),
      TnIconDownloadCompleteTray: n(() => import("./TnIcondownload-complete-tray-Cixu1k0K.js")),
      TnIconDownloadProgressCircle: n(() => import("./TnIcondownload-progress-circle-Da38HvHl.js")),
      TnIconDownloadToBox: n(() => import("./TnIcondownload-to-box-JntiyWpu.js")),
      TnIconDownloadTray: n(() => import("./TnIcondownload-tray-DReDS5kQ.js")),
      TnIconDragDots: n(() => import("./TnIcondrag-dots-B3R-jbei.js")),
      TnIconDragHandleHorisontal: n(() => import("./TnIcondrag-handle-horisontal-Bf3lulZZ.js")),
      TnIconDragHandleVertical: n(() => import("./TnIcondrag-handle-vertical-Z5XScthR.js")),
      TnIconEdit: n(() => import("./TnIconedit-ByoTHcSS.js")),
      TnIconEmail: n(() => import("./TnIconemail-Ci2PSYIz.js")),
      TnIconEmployee: n(() => import("./TnIconemployee-CNkAGQTK.js")),
      TnIconErrorCircleFilled: n(() => import("./TnIconerror-circle-filled-Cpsv1yFw.js")),
      TnIconErrorCircleFlat: n(() => import("./TnIconerror-circle-flat-BpCgaw-V.js")),
      TnIconErrorCircleOutline: n(() => import("./TnIconerror-circle-outline-AzdLSRNQ.js")),
      TnIconeSim: n(() => import("./TnIcone-sim-B0ZU0kHf.js")),
      TnIconEthernet: n(() => import("./TnIconethernet-PlmKFogF.js")),
      TnIconExpand: n(() => import("./TnIconexpand-CJu7cjzP.js")),
      TnIconExpandInputBox: n(() => import("./TnIconexpand-input-box-DoNy1_lS.js")),
      TnIconExpandScreen: n(() => import("./TnIconexpand-screen-US4ebdD9.js")),
      TnIconExperiment: n(() => import("./TnIconexperiment-BSW6Mb1X.js")),
      TnIconExpressDelivery: n(() => import("./TnIconexpress-delivery-BAXzEq8u.js")),
      TnIconExternalLink: n(() => import("./TnIconexternal-link-bTQScKkj.js")),
      TnIconEyeClosed: n(() => import("./TnIconeye-closed-DhSvg3yP.js")),
      TnIconEyeOff: n(() => import("./TnIconeye-off-CLvgeEar.js")),
      TnIconEyeOpen: n(() => import("./TnIconeye-open-BS_RXu1Y.js")),
      TnIconFacebook: n(() => import("./TnIconfacebook-LMrjd342.js")),
      TnIconFaceDissatisfied: n(() => import("./TnIconface-dissatisfied-B1IOgyVJ.js")),
      TnIconFaceDissatisfiedFilled: n(() => import("./TnIconface-dissatisfied-filled-C1d1vlvx.js")),
      TnIconFaceHappy: n(() => import("./TnIconface-happy-DCZPg527.js")),
      TnIconFaceHappyFilled: n(() => import("./TnIconface-happy-filled-DKgaRAs_.js")),
      TnIconFaceID: n(() => import("./TnIconface-id-uhy4-Rpp.js")),
      TnIconFaceNeutral: n(() => import("./TnIconface-neutral-Bhh8LY8J.js")),
      TnIconFaceNeutralFilled: n(() => import("./TnIconface-neutral-filled-B7P2VMC4.js")),
      TnIconFaceSatisfied: n(() => import("./TnIconface-satisfied-8BCKzveP.js")),
      TnIconFaceSatisfiedFilled: n(() => import("./TnIconface-satisfied-filled-EXX_EaK9.js")),
      TnIconFaceUnhappy: n(() => import("./TnIconface-unhappy-CP-nb-65.js")),
      TnIconFaceUnhappyFilled: n(() => import("./TnIconface-unhappy-filled-BpPopD9P.js")),
      TnIconFamily: n(() => import("./TnIconfamily-BGuSQb_R.js")),
      TnIconFiber: n(() => import("./TnIconfiber-CAZsWi44.js")),
      TnIconFigma: n(() => import("./TnIconfigma-Da4zSf_S.js")),
      TnIconFigmaOutline: n(() => import("./TnIconfigma-outline-Dkgq--sG.js")),
      TnIconFilter: n(() => import("./TnIconfilter-B9wf_ql_.js")),
      TnIconFingerprint: n(() => import("./TnIconfingerprint-DCrTxzee.js")),
      TnIconFlagFilled: n(() => import("./TnIconflag-filled-BpuI0W67.js")),
      TnIconFlagOutline: n(() => import("./TnIconflag-outline-hBXl9pQu.js")),
      TnIconFloppy: n(() => import("./TnIconfloppy-COeVFV7z.js")),
      TnIconFolder: n(() => import("./TnIconfolder-9F5DBl1g.js")),
      TnIconFolderAdd: n(() => import("./TnIconfolder-add-mZxTH_IC.js")),
      TnIconFolders: n(() => import("./TnIconfolders-Fu_BVvIL.js")),
      TnIconFreeDeliveryAndReturns: n(() => import("./TnIconfree-delivery-and-returns-Dm9yYZ0p.js")),
      TnIconFullScreen: n(() => import("./TnIconfull-screen-DMRrdseE.js")),
      TnIconGenre: n(() => import("./TnIcongenre-CMokRbVr.js")),
      TnIconGift: n(() => import("./TnIcongift-HjX7_Vcd.js")),
      TnIconGithub: n(() => import("./TnIcongithub-9Vc1F6N9.js")),
      TnIconGlobe: n(() => import("./TnIconglobe-BlXaOY8O.js")),
      TnIconGraph: n(() => import("./TnIcongraph-BoizlNCo.js")),
      TnIconHardOfHearing: n(() => import("./TnIconhard-of-hearing-Bk8BRpQF.js")),
      TnIconHashtag: n(() => import("./TnIconhashtag-bKDLV5gs.js")),
      TnIconHashtagCircleFilled: n(() => import("./TnIconhashtag-circle-filled-CNrjZD9O.js")),
      TnIconHashtagCircleOutline: n(() => import("./TnIconhashtag-circle-outline-D32QKPEg.js")),
      TnIconHeartFilled: n(() => import("./TnIconheart-filled-BiL83F12.js")),
      TnIconHeartOutline: n(() => import("./TnIconheart-outline-aKt7SJJH.js")),
      TnIconHelp: n(() => import("./TnIconhelp-BL9wFncy.js")),
      TnIconHistory: n(() => import("./TnIconhistory-ByyiEFPk.js")),
      TnIconHome: n(() => import("./TnIconhome-CPu7akvk.js")),
      TnIconHourglass: n(() => import("./TnIconhourglass-CFKTbjI-.js")),
      TnIconHourglassFinished: n(() => import("./TnIconhourglass-finished-CbRjToRB.js")),
      TnIconHourglassRunning: n(() => import("./TnIconhourglass-running-BckpEspj.js")),
      TnIconImage: n(() => import("./TnIconimage-BP1hmYe6.js")),
      TnIconImageFilled: n(() => import("./TnIconimage-filled-CfB4YP2k.js")),
      TnIconInfinity: n(() => import("./TnIconinfinity-BSQ7-qxr.js")),
      TnIconInfoCircleFilled: n(() => import("./TnIconinfo-circle-filled-CH_SniCi.js")),
      TnIconInfoCircleFlat: n(() => import("./TnIconinfo-circle-flat-DCd1KcGA.js")),
      TnIconInfoCircleOutline: n(() => import("./TnIconinfo-circle-outline-DMI-GxlV.js")),
      TnIconInfoStandalone: n(() => import("./TnIconinfo-standalone-CRlOf1b2.js")),
      TnIconInstagram: n(() => import("./TnIconinstagram-DmRRONxW.js")),
      TnIconInvoice: n(() => import("./TnIconinvoice-Qd8c-yM9.js")),
      TnIconInvoiceAccount: n(() => import("./TnIconinvoice-account-Rcslbq0t.js")),
      TnIconIoTSim: n(() => import("./TnIconio-t-sim-BLZQIpBg.js")),
      TnIconKey: n(() => import("./TnIconkey-BVL2vlwu.js")),
      TnIconKeypad: n(() => import("./TnIconkeypad-DWCnxWTh.js")),
      TnIconKI: n(() => import("./TnIconki-CFz4Nti4.js")),
      TnIconKIFilled: n(() => import("./TnIconki-filled-CCpvBaoq.js")),
      TnIconKIOutline: n(() => import("./TnIconki-outline-Ybw0zaRJ.js")),
      TnIconKISymbolOutline: n(() => import("./TnIconki-symbol-outline-oVPrcWle.js")),
      TnIconKroner: n(() => import("./TnIconkroner-CAvcqOwW.js")),
      TnIconLan: n(() => import("./TnIconlan-DoK2mBhB.js")),
      TnIconLaptop: n(() => import("./TnIconlaptop-DsrTqXDi.js")),
      TnIconLeft: n(() => import("./TnIconleft-D76RHz6B.js")),
      TnIconLightbulb: n(() => import("./TnIconlightbulb-Crt3XRre.js")),
      TnIconLightMode: n(() => import("./TnIconlight-mode-CK_klFIR.js")),
      TnIconLightModeFilled: n(() => import("./TnIconlight-mode-filled-CIC4_D4Y.js")),
      TnIconLightningFilled: n(() => import("./TnIconlightning-filled-BbZQy_3R.js")),
      TnIconLightningFilledwithOutline: n(() => import("./TnIconlightning-filledwith-outline-Df6JmPZX.js")),
      TnIconLightningOutline: n(() => import("./TnIconlightning-outline-D0_wbErZ.js")),
      TnIconLink: n(() => import("./TnIconlink-oXUkRU8W.js")),
      TnIconLink2: n(() => import("./TnIconlink2-C6hrzUHP.js")),
      TnIconLinkedIn: n(() => import("./TnIconlinked-in-BmTy8luA.js")),
      TnIconLive: n(() => import("./TnIconlive-C7LsFY-p.js")),
      TnIconLocation: n(() => import("./TnIconlocation-BayfYkFi.js")),
      TnIconLocationFilled: n(() => import("./TnIconlocation-filled-Xu4G2VWt.js")),
      TnIconLocationFilledwithOutline: n(() => import("./TnIconlocation-filledwith-outline-CrOOu1n6.js")),
      TnIconLockFilledClosed: n(() => import("./TnIconlock-filled-closed-BGDhQZRC.js")),
      TnIconLockFilledOpen: n(() => import("./TnIconlock-filled-open-M8Abwmfg.js")),
      TnIconLockOutlineClosed: n(() => import("./TnIconlock-outline-closed-Dffgv_hb.js")),
      TnIconLockOutlineOpen: n(() => import("./TnIconlock-outline-open-B8E5JvZl.js")),
      TnIconLog: n(() => import("./TnIconlog-DbQ-z0KD.js")),
      TnIconLogIn: n(() => import("./TnIconlog-in-D7iw2Fz_.js")),
      TnIconLogOut: n(() => import("./TnIconlog-out-CYsapQ9R.js")),
      TnIconLongDown: n(() => import("./TnIconlong-down-D3KEYT2N.js")),
      TnIconLongLeft: n(() => import("./TnIconlong-left-Box-AAaU.js")),
      TnIconLongRight: n(() => import("./TnIconlong-right-C01nEmwI.js")),
      TnIconLongUp: n(() => import("./TnIconlong-up-BUaE7ACZ.js")),
      TnIconMaximise: n(() => import("./TnIconmaximise-Dk4RanN8.js")),
      TnIconMBN: n(() => import("./TnIconmbn-L5iR0t0n.js")),
      TnIconMegaphone: n(() => import("./TnIconmegaphone-BRcx7RlR.js")),
      TnIconMenu: n(() => import("./TnIconmenu-DDDqGXZK.js")),
      TnIconMessage: n(() => import("./TnIconmessage-Cbyk-HSP.js")),
      TnIconMicrophoneOff: n(() => import("./TnIconmicrophone-off-Dsiqw9mI.js")),
      TnIconMicrophoneOn: n(() => import("./TnIconmicrophone-on-C5Ub47FH.js")),
      TnIconMicrosoftOffice: n(() => import("./TnIconmicrosoft-office-DSB9qqZM.js")),
      TnIconMinimise: n(() => import("./TnIconminimise-Dw63kDua.js")),
      TnIconMinus: n(() => import("./TnIconminus-C11yT4dR.js")),
      TnIconMinusCircleFilled: n(() => import("./TnIconminus-circle-filled-4E_0xdlu.js")),
      TnIconMinusCircleOutline: n(() => import("./TnIconminus-circle-outline-BEf5HDfQ.js")),
      TnIconMonitor: n(() => import("./TnIconmonitor-E7yEW53o.js")),
      TnIconMovieArchive: n(() => import("./TnIconmovie-archive-xgcQn4eJ.js")),
      TnIconMovieClip: n(() => import("./TnIconmovie-clip-BcRAdjKw.js")),
      TnIconMovies: n(() => import("./TnIconmovies-CRUMMdgw.js")),
      TnIconMusic: n(() => import("./TnIconmusic-CV5ybHrO.js")),
      TnIconNearMeOff: n(() => import("./TnIconnear-me-off-nS8FFqxZ.js")),
      TnIconNearMeOn: n(() => import("./TnIconnear-me-on-BRc5nCbY.js")),
      TnIconNoBinding: n(() => import("./TnIconno-binding-Bct1JARj.js")),
      TnIconNotificationFilled: n(() => import("./TnIconnotification-filled-De6d-n71.js")),
      TnIconNotificationNew: n(() => import("./TnIconnotification-new-B3_ljRk_.js")),
      TnIconNotificationNone: n(() => import("./TnIconnotification-none-BGAaJLBn.js")),
      TnIconOpeninnewWindow: n(() => import("./TnIconopeninnew-window-iVlN7lQy.js")),
      TnIconOpenPanelLeft: n(() => import("./TnIconopen-panel-left-DH1OuIR5.js")),
      TnIconOpenPanelRight: n(() => import("./TnIconopen-panel-right-CTqKak_W.js")),
      TnIconOverflowMenuHorizontal: n(() => import("./TnIconoverflow-menu-horizontal-_REXe95l.js")),
      TnIconOverflowMenuVertical: n(() => import("./TnIconoverflow-menu-vertical-CbbIiYxM.js")),
      TnIconPaperclip: n(() => import("./TnIconpaperclip-iAWG7W-M.js")),
      TnIconPasskey: n(() => import("./TnIconpasskey-DTvo9Guz.js")),
      TnIconPaste: n(() => import("./TnIconpaste-PYfZY5kb.js")),
      TnIconPause: n(() => import("./TnIconpause-Bm9QXygp.js")),
      TnIconPauseCircleOutline: n(() => import("./TnIconpause-circle-outline-D8vWwc5_.js")),
      TnIconPauseLarge: n(() => import("./TnIconpause-large-BXgbJLM-.js")),
      TnIconPendingCircleFilled: n(() => import("./TnIconpending-circle-filled-nHjUVBlm.js")),
      TnIconPendingCircleFlat: n(() => import("./TnIconpending-circle-flat-DanGR0-z.js")),
      TnIconPendingCircleOutline: n(() => import("./TnIconpending-circle-outline-3Y0gg3J0.js")),
      TnIconPeople: n(() => import("./TnIconpeople-Bmqg00f-.js")),
      TnIconPerson: n(() => import("./TnIconperson-BSgAtoS0.js")),
      TnIconPhoneLandline: n(() => import("./TnIconphone-landline-C9pAey2Y.js")),
      TnIconPhoneMobile: n(() => import("./TnIconphone-mobile-g5GmmSiO.js")),
      TnIconPhoneReceiver: n(() => import("./TnIconphone-receiver-Dse2HEZl.js")),
      TnIconPhoneReceiverFilled: n(() => import("./TnIconphone-receiver-filled-Dgx2BGD-.js")),
      TnIconPickUp: n(() => import("./TnIconpick-up-C51gjd4x.js")),
      TnIconPictureInPictureIn: n(() => import("./TnIconpicture-in-picture-in-Cdm_JGWN.js")),
      TnIconPictureinPictureOut: n(() => import("./TnIconpicturein-picture-out-BGCWo9XF.js")),
      TnIconPieChart: n(() => import("./TnIconpie-chart-6SiviZBr.js")),
      TnIconPlan: n(() => import("./TnIconplan-DUxj8VTF.js")),
      TnIconPlay: n(() => import("./TnIconplay-DPgc6urR.js")),
      TnIconPlayCircleOutline: n(() => import("./TnIconplay-circle-outline-DvG2s8Ie.js")),
      TnIconPlayFilled: n(() => import("./TnIconplay-filled-C9NXv1KM.js")),
      TnIconPlayLarge: n(() => import("./TnIconplay-large-DbdylTTt.js")),
      TnIconPlayOnBox: n(() => import("./TnIconplay-on-box-Db88b6OJ.js")),
      TnIconPlayOnFetch: n(() => import("./TnIconplay-on-fetch-B3_etf3T.js")),
      TnIconPlus: n(() => import("./TnIconplus-vBYVdx_1.js")),
      TnIconPlusCircleFilled: n(() => import("./TnIconplus-circle-filled-D7jbUr9N.js")),
      TnIconPlusCircleOutline: n(() => import("./TnIconplus-circle-outline-meqctP_k.js")),
      TnIconPointer: n(() => import("./TnIconpointer-DkaEmTaY.js")),
      TnIconPointerFilled: n(() => import("./TnIconpointer-filled-9gNoGO-T.js")),
      TnIconPointerRays: n(() => import("./TnIconpointer-rays-C2UgYvvn.js")),
      TnIconPointerRaysFilled: n(() => import("./TnIconpointer-rays-filled-4bR3MOTz.js")),
      TnIconPointerRipples: n(() => import("./TnIconpointer-ripples-CJu_JV1T.js")),
      TnIconPointerRipplesFilled: n(() => import("./TnIconpointer-ripples-filled-dlENu47W.js")),
      TnIconPrinter: n(() => import("./TnIconprinter-DUmHQ8Ff.js")),
      TnIconPushPinFilled: n(() => import("./TnIconpush-pin-filled-o_QT_CUS.js")),
      TnIconPushPinOutline: n(() => import("./TnIconpush-pin-outline-E02cS00D.js")),
      TnIconQr: n(() => import("./TnIconqr-CQgpIKzl.js")),
      TnIconQuestion: n(() => import("./TnIconquestion-CMvpNLFH.js")),
      TnIconQuestionCircleFilled: n(() => import("./TnIconquestion-circle-filled-C5gLvnKw.js")),
      TnIconQuestionCircleOutline: n(() => import("./TnIconquestion-circle-outline-C11dhXi2.js")),
      TnIconQueue: n(() => import("./TnIconqueue-GGFlyylA.js")),
      TnIconRadio: n(() => import("./TnIconradio-D99o_7Vh.js")),
      TnIconRadioButtonChecked: n(() => import("./TnIconradio-button-checked-BnwZhpCn.js")),
      TnIconRadioButtonUnchecked: n(() => import("./TnIconradio-button-unchecked-BV_Z0Zsa.js")),
      TnIconRec: n(() => import("./TnIconrec-CRstvFyM.js")),
      TnIconReceipt: n(() => import("./TnIconreceipt-hzhSkVUC.js")),
      TnIconRecycle: n(() => import("./TnIconrecycle-De8UrgXD.js")),
      TnIconRedo: n(() => import("./TnIconredo-CoyDhqqK.js")),
      TnIconRefresh: n(() => import("./TnIconrefresh-CxpBxnho.js")),
      TnIconReload: n(() => import("./TnIconreload-4u04SkF-.js")),
      TnIconRemoteControl: n(() => import("./TnIconremote-control-DZi9SEzg.js")),
      TnIconRemove: n(() => import("./TnIconremove-BlfzRflP.js")),
      TnIconRemoveCircleFilled: n(() => import("./TnIconremove-circle-filled-CFioRKqn.js")),
      TnIconRemoveCircleOutline: n(() => import("./TnIconremove-circle-outline-B5v1YXJ3.js")),
      TnIconResumeWatching: n(() => import("./TnIconresume-watching-BfyhB6x3.js")),
      TnIconRight: n(() => import("./TnIconright-C8GprpA4.js")),
      TnIconRouter: n(() => import("./TnIconrouter-DPzmNdiR.js")),
      TnIconRouting: n(() => import("./TnIconrouting-WDgr-x7K.js")),
      TnIconSearch: n(() => import("./TnIconsearch-BOFGZLd5.js")),
      TnIconSecurity: n(() => import("./TnIconsecurity-Cj6mnQrO.js")),
      TnIconSecurityAlert: n(() => import("./TnIconsecurity-alert-aWUcTJxq.js")),
      TnIconSecurityOff: n(() => import("./TnIconsecurity-off-C9HP0mp5.js")),
      TnIconSecurityOn: n(() => import("./TnIconsecurity-on-jXsrFMhM.js")),
      TnIconSend: n(() => import("./TnIconsend--h6AZ8oq.js")),
      TnIconSeries: n(() => import("./TnIconseries-QskG42WB.js")),
      TnIconSeriesArchive: n(() => import("./TnIconseries-archive-CB1Z-ThY.js")),
      TnIconService: n(() => import("./TnIconservice-Dz12RMor.js")),
      TnIconServices: n(() => import("./TnIconservices-CJl_4gvF.js")),
      TnIconSettings: n(() => import("./TnIconsettings-DxeXlphy.js")),
      TnIconSettingsComplex: n(() => import("./TnIconsettings-complex-DRqyjz5I.js")),
      TnIconShare: n(() => import("./TnIconshare-CS-K7wbd.js")),
      TnIconShareContent: n(() => import("./TnIconshare-content-rHOgf-mf.js")),
      TnIconShovel: n(() => import("./TnIconshovel-CRGSEy4w.js")),
      TnIconSim: n(() => import("./TnIconsim-Bx3G8xVz.js")),
      TnIconSkipBack10s: n(() => import("./TnIconskip-back10s-B0Fqg4ID.js")),
      TnIconSkipBackward15s: n(() => import("./TnIconskip-backward15s-CrxlTJDo.js")),
      TnIconSkipBackward30s: n(() => import("./TnIconskip-backward30s-CKIlfokz.js")),
      TnIconSkipForward: n(() => import("./TnIconskip-forward-BLUJhcR-.js")),
      TnIconSkipForward10s: n(() => import("./TnIconskip-forward10s-CD6DPtLv.js")),
      TnIconSkipForward15s: n(() => import("./TnIconskip-forward15s-umnloC2Q.js")),
      TnIconSkipForward30s: n(() => import("./TnIconskip-forward30s-DYTwejrG.js")),
      TnIconSkiptoNext: n(() => import("./TnIconskipto-next-DNcAN1ME.js")),
      TnIconSkiptoPrevious: n(() => import("./TnIconskipto-previous-lb85Go1_.js")),
      TnIconSlack: n(() => import("./TnIconslack-C7b-itAy.js")),
      TnIconSlackNegative: n(() => import("./TnIconslack-negative-Bn9jLSBb.js")),
      TnIconSms: n(() => import("./TnIconsms-BHf0e8Iv.js")),
      TnIconSoftphoneConnected: n(() => import("./TnIconsoftphone-connected-CvYfhd_W.js")),
      TnIconSoftphoneDisconnected: n(() => import("./TnIconsoftphone-disconnected-CKBEnc7r.js")),
      TnIconSort: n(() => import("./TnIconsort-CD4CdSVZ.js")),
      TnIconSortDown: n(() => import("./TnIconsort-down-i5fXweTz.js")),
      TnIconSortFilled: n(() => import("./TnIconsort-filled-CQ94_3Ok.js")),
      TnIconSortHorizontal: n(() => import("./TnIconsort-horizontal-CUkI5f2Z.js")),
      TnIconSortOutline: n(() => import("./TnIconsort-outline-4z617cUM.js")),
      TnIconSortUp: n(() => import("./TnIconsort-up-QTMw8bRr.js")),
      TnIconSoundWave: n(() => import("./TnIconsound-wave-dZ3x4PfH.js")),
      TnIconSpaceBar: n(() => import("./TnIconspace-bar-IqEg7ExX.js")),
      TnIconSpeakerOff: n(() => import("./TnIconspeaker-off-DTJ4eDzZ.js")),
      TnIconSpeakerOn: n(() => import("./TnIconspeaker-on-BKcRE6IC.js")),
      TnIconSpeed: n(() => import("./TnIconspeed-26v4ev4l.js")),
      TnIconSpinner: n(() => import("./TnIconspinner-DBQ0P-RD.js")),
      TnIconSplit: n(() => import("./TnIconsplit-fyNqOKUg.js")),
      TnIconSport: n(() => import("./TnIconsport-Czgzvhjv.js")),
      TnIconStarFilled: n(() => import("./TnIconstar-filled-BNKzPuT4.js")),
      TnIconStarOutline: n(() => import("./TnIconstar-outline-C7bRJjbA.js")),
      TnIconStartOver: n(() => import("./TnIconstart-over-CHPr4sFw.js")),
      TnIconStop: n(() => import("./TnIconstop-BENTh5gc.js")),
      TnIconStorage: n(() => import("./TnIconstorage-wp8JIA75.js")),
      TnIconStorybook: n(() => import("./TnIconstorybook-ujE3nyRL.js")),
      TnIconStorybookNegative: n(() => import("./TnIconstorybook-negative-BiADxKUR.js")),
      TnIconSubdirectoryLeft: n(() => import("./TnIconsubdirectory-left-D6nO0nZK.js")),
      TnIconSubdirectoryRight: n(() => import("./TnIconsubdirectory-right-C5wQRFkm.js")),
      TnIconSubscription: n(() => import("./TnIconsubscription-CH7VMhHr.js")),
      TnIconSubtitles: n(() => import("./TnIconsubtitles-B8gHItQL.js")),
      TnIconSuccess: n(() => import("./TnIconsuccess-ONSrIbGm.js")),
      TnIconSuccessCircleFilled: n(() => import("./TnIconsuccess-circle-filled-B8CYxXE0.js")),
      TnIconSuccessCircleFlat: n(() => import("./TnIconsuccess-circle-flat-14pezlov.js")),
      TnIconSuccessCircleOutline: n(() => import("./TnIconsuccess-circle-outline-D0wHXOcQ.js")),
      TnIconTableofContent: n(() => import("./TnIcontableof-content-B8hmk9VA.js")),
      TnIconTag: n(() => import("./TnIcontag-d-WgCChh.js")),
      TnIconTagFilled: n(() => import("./TnIcontag-filled-BPVE4bQp.js")),
      TnIconTelegrafen: n(() => import("./TnIcontelegrafen-BJBKQutb.js")),
      TnIconTelegrafen1px: n(() => import("./TnIcontelegrafen1px-BBx_lvM0.js")),
      TnIconTelenor: n(() => import("./TnIcontelenor-DXIfzjCg.js")),
      TnIconTelenorNegative: n(() => import("./TnIcontelenor-negative-em9si-Sm.js")),
      TnIconTelmi: n(() => import("./TnIcontelmi-DdRPpMdv.js")),
      TnIconThumbsDownFilled: n(() => import("./TnIconthumbs-down-filled-_AhfHFVw.js")),
      TnIconThumbsDownOutline: n(() => import("./TnIconthumbs-down-outline-Ds0LqHB6.js")),
      TnIconThumbsUpFilled: n(() => import("./TnIconthumbs-up-filled-17MOU4Jp.js")),
      TnIconThumbsUpOutline: n(() => import("./TnIconthumbs-up-outline-B3eAs-h6.js")),
      TnIconTickets: n(() => import("./TnIcontickets-BnjK4w6Z.js")),
      TnIconTimer: n(() => import("./TnIcontimer-CKGM3fbQ.js")),
      TnIconToDo: n(() => import("./TnIconto-do-DmfaLmp2.js")),
      TnIconTrafficCone: n(() => import("./TnIcontraffic-cone-C8MCJEUR.js")),
      TnIconTrashcan: n(() => import("./TnIcontrashcan-BdOlksMr.js")),
      TnIconTrashcanOpen: n(() => import("./TnIcontrashcan-open-D1id9yCM.js")),
      TnIconTrendingDown: n(() => import("./TnIcontrending-down-BI_VSQ31.js")),
      TnIconTrendingStable: n(() => import("./TnIcontrending-stable-BIt_TPY4.js")),
      TnIconTrendingUp: n(() => import("./TnIcontrending-up-BBAhQ8ra.js")),
      TnIconTv: n(() => import("./TnIcontv-DUCfPGSb.js")),
      TnIconTvArchive: n(() => import("./TnIcontv-archive-D_GhHqS_.js")),
      TnIconTvGuide: n(() => import("./TnIcontv-guide-CIAbxG06.js")),
      TnIconTWeBox: n(() => import("./TnIcont-we-box-2Q7XKzmn.js")),
      TnIconTwitterLegacy: n(() => import("./TnIcontwitter-legacy-C_TOYqza.js")),
      TnIconUnavailable: n(() => import("./TnIconunavailable-CZ-8aNY5.js")),
      TnIconUndo: n(() => import("./TnIconundo-ClSGprS4.js")),
      TnIconUp: n(() => import("./TnIconup-Dra4SwJV.js")),
      TnIconUploadTray: n(() => import("./TnIconupload-tray-D4e9hY54.js")),
      TnIconVideocameraOn: n(() => import("./TnIconvideocamera-on-BqBlt1DY.js")),
      TnIconVideoOnDemand: n(() => import("./TnIconvideo-on-demand-CWrk0IqM.js")),
      TnIconViewCard: n(() => import("./TnIconview-card-L-KOKFr8.js")),
      TnIconViewHorizontalCard: n(() => import("./TnIconview-horizontal-card-BD_zUJGD.js")),
      TnIconViewList: n(() => import("./TnIconview-list-McXpJAib.js")),
      TnIconViewTable: n(() => import("./TnIconview-table-DDf8YOqd.js")),
      TnIconVipps: n(() => import("./TnIconvipps-CXZzMZXc.js")),
      TnIconVippsApp: n(() => import("./TnIconvipps-app-DHkQ1sOQ.js")),
      TnIconVippsAppNegative: n(() => import("./TnIconvipps-app-negative-BLVymksy.js")),
      TnIconVoicemail: n(() => import("./TnIconvoicemail-BlUL2Qdm.js")),
      TnIconWarningCircleFilled: n(() => import("./TnIconwarning-circle-filled-5CQbsGMg.js")),
      TnIconWarningCircleFlat: n(() => import("./TnIconwarning-circle-flat-BbHgtT5o.js")),
      TnIconWarningCircleOutline: n(() => import("./TnIconwarning-circle-outline-6lBFZVnU.js")),
      TnIconWatch: n(() => import("./TnIconwatch-Kpb08ONA.js")),
      TnIconWeeklyArchive: n(() => import("./TnIconweekly-archive-B00vLSPD.js")),
      TnIconWiFi: n(() => import("./TnIconwi-fi-DygGw8fm.js")),
      TnIconWiFiHome: n(() => import("./TnIconwi-fi-home-nPvx59kD.js")),
      TnIconWizard: n(() => import("./TnIconwizard-78PR30-G.js")),
      TnIconX: n(() => import("./TnIconx-diLZn4Fh.js")),
      TnIconYouTube: n(() => import("./TnIconyou-tube-DuIJOhdT.js")),
      TnIconZoomIn: n(() => import("./TnIconzoom-in-t2R9AhZn.js")),
      TnIconZoomOut: n(() => import("./TnIconzoom-out-DXJXENsg.js"))
    }, a = m(() => {
      if (!o.name) return null;
      const i = Object.keys(c).find((e) => e.toLowerCase() === `tnicon${o.name.toLowerCase().replace(/-/g, "")}`);
      return i ? c[i] : null;
    });
    return (i, e) => (C(), u(F(a.value || h(r)), {
      height: t.value,
      width: t.value,
      fill: i.color
    }, null, 8, ["height", "width", "fill"]));
  }
});
export {
  f as TnIcon
};
